import React, { useEffect, useState } from "react";
import Input from "../../../component/common/Input";
import Button from "../../../component/common/Button";
import { toast } from "react-toastify";
import httpServices from "../../../services/httpServices";

const EventPayments = (eventId) => {

  const [formData, setFormData] = useState({
    accountHolderName: "",
    bankName: "",
    bankBranchName: "",
    accountNumber: "",
    confirmAccountNumber: "",
    iban: "",
    vatId: "",
    vatRegistrationNumber: "",
    companyName: "",
    companyOwnerName: "",
    companyOwnerEmiratesId: "",
    emiratesIdUrl: "",
    companyLocation: "",
    dtcmForm: "",
    dtcmLink: "",
    eventId
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    // Validation
    if (formData.accountNumber !== formData.confirmAccountNumber) {
      toast.error("Account numbers do not match");
      return;
    }

    const payload = {
      ...formData,
      eventId: 1, // Replace with dynamic eventId if needed
    };

    try {
      const response = await httpServices.post(
        "/eventPaymentInfo/create",
        payload
      );
      if (response) {
        toast.success("Payment information saved successfully");
        // Add navigation or other actions here
      }
    } catch (error) {
      toast.error("Failed to save payment information");
    }
  };

  return (
    <div className=" p-3 my-4 sm:p-4 max-w-7xl bg-white rounded-[10px] min-h-[600px]">
      <h1 className="gradient-text font-semibold text-xl">
        Payment Information
      </h1>

      <div className="mt-4 grid gap-4 grid-cols-1 sm:grid-cols-2">
        <Input
          label="Account Holder Name*"
          placeholder="Enter detail"
          name="accountHolderName"
          value={formData.accountHolderName}
          onChange={handleChange}
          inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#06152B]"
          lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
        />
        <Input
          label="Bank Name*"
          placeholder="Enter detail"
          name="bankName"
          value={formData.bankName}
          onChange={handleChange}
          inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#06152B]"
          lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
        />
        <Input
          label="Account Number*"
          placeholder="Enter Account Number"
          name="accountNumber"
          value={formData.accountNumber}
          onChange={handleChange}
          inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#06152B]"
          lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
        />
        <Input
          label="Re Enter Account Number*"
          placeholder="Re Enter Account Number"
          name="reEnterAccountNumber"
          value={formData.reEnterAccountNumber}
          onChange={handleChange}
          inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#06152B]"
          lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
        />
        <Input
          label="Bank Branch Name*"
          placeholder="Enter Bank Branch"
          name="bankBranchName"
          value={formData.bankBranchName}
          onChange={handleChange}
          inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#06152B]"
          lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
        />
        <Input
          label="IBAN*"
          placeholder="Enter IBAN"
          name="iban"
          value={formData.iban}
          onChange={handleChange}
          inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#06152B]"
          lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
        />
        <Input
          label="VAT ID*"
          placeholder="Enter VAT ID"
          name="vatId"
          value={formData.vatId}
          onChange={handleChange}
          inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#06152B]"
          lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
        />
        <Input
          label="VAT Registration Number*"
          placeholder="Enter VAT Reg No"
          name="vatRegistrationNumber"
          value={formData.vatRegistrationNumber}
          onChange={handleChange}
          inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#06152B]"
          lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
        />

      </div>
      <h1 className="gradient-text font-semibold text-xl mt-[28px]">
        Company Details
      </h1>

      <div className="mt-4 grid gap-4 grid-cols-1 sm:grid-cols-2">
        <Input
          label="Company Name*"
          placeholder="Enter Company name"
          name="companyName"
          value={formData.companyName}
          onChange={handleChange}
          inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#06152B]"
          lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
        />
        <Input
          label="Owner Name*"
          placeholder="Enter Owner name"
          name="companyOwnerName"
          value={formData.companyOwnerName}
          onChange={handleChange}
          inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#06152B]"
          lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
        />
        <Input
          label="Owner Emirates ID*"
          placeholder="Enter Owner Emirates ID"
          name="companyOwnerEmiratesId"
          value={formData.companyOwnerEmiratesId}
          onChange={handleChange}
          inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#06152B]"
          lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
        />
        <Input
          label="Link to Upload Emirates ID*"
          placeholder="Upload link"
          name="emiratesIdUrl"
          value={formData.emiratesIdUrl}
          onChange={handleChange}
          inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#06152B]"
          lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
        />
        <Input
          label="Location*"
          placeholder="Enter Location"
          name="companyLocation"
          value={formData.companyLocation}
          onChange={handleChange}
          inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#06152B]"
          lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
        />

      </div>
      <h1 className="gradient-text font-semibold text-xl mt-[28px]">
        Premissions
      </h1>

      <div className="mt-4 grid gap-4 grid-cols-1 sm:grid-cols-2">
        <Input
          label="DTCM Form*"
          placeholder="Enter detail"
          name="dtcmForm"
          value={formData.dtcmForm}
          onChange={handleChange}
          inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#06152B]"
          lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
        />
        <Input
          label="DTCM Link*"
          placeholder="Enter Link"
          name="dtcmLink"
          value={formData.dtcmLink}
          onChange={handleChange}
          inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#06152B]"
          lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
        />
      </div>

      <div className="flex justify-center mt-[26px]">
        <Button
          content="Save & Proceed"
          classes="py-[11px]  px-[40px] sm:px-[81px] text-sm bg-gradient-to-t from-dark-blue to-[#FFFFFF1F]"

        />

      </div>
    </div>
  );
};

export default EventPayments;
